import { Stack } from '@mui/system';
import { Typography } from '@mui/material';
import {
  mapCompanySize,
  mapCountry,
  mapProjectSize,
  mapHourlyRate,
  EnumCountry,
  EnumCompanySize,
  EnumProjectSize,
  EnumProjectHourlyRate,
} from 'tdc-web-backend/enums/enums';
import { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import CustomChip from '../../../../../../../../../components/custom-chip/CustomChip';
import CompanyOverviewEditModal from './components/CompanyOverviewEditModal';
import { truncate } from '../../../../../../../../../utils/helpers';
import useUserCompany from '../../../../../../../../../utils/hooks/useUserCompany';
import { CHIP_LABEL_TRUNCATE_VALUE } from '../../../../../../../../../utils/constants';

interface CompanyOverviewModal {
  isOverviewModalOpen: boolean;
  setIsOverviewModalOpen: Dispatch<SetStateAction<boolean>>;
}

const CompanyOverview = ({ isOverviewModalOpen, setIsOverviewModalOpen }: CompanyOverviewModal) => {
  const { company: companyData } = useUserCompany();
  const { t } = useTranslation();
  return (
    <Stack width="100%" spacing={1}>
      {[
        {
          label: t('settings.companyProfile.overviewDetails.companySize'),
          value: mapCompanySize.get(companyData?.companySize as EnumCompanySize),
          // value: companyData?.companySize as EnumCompanySize,
        },
        {
          label: t('settings.companyProfile.overviewDetails.headquarters'),
          value: companyData?.headquartersLocation?.state
            ? `${companyData?.headquartersLocation.city}, ${
                companyData?.headquartersLocation.state
              }, ${mapCountry.get(companyData?.headquartersLocation?.country as EnumCountry)}`
            : `${companyData?.headquartersLocation?.city}, ${mapCountry.get(
                companyData?.headquartersLocation?.country as EnumCountry,
              )}`,
        },
        // { label: 'FOUNDED', value: companyData?.founded },
        {
          label: t('settings.companyProfile.overviewDetails.avgProjectSize'),
          value: mapProjectSize.get(companyData?.averageProjectSize as EnumProjectSize),
        },
        {
          label: t('settings.companyProfile.overviewDetails.hourlyRate'),
          value: mapHourlyRate.get(companyData?.hourlyRate as EnumProjectHourlyRate),
        },
      ].map((data, index) => (
        <Stack
          key={index}
          direction={{ xl: 'row' }}
          justifyContent="flex-start"
          gap={1}
          alignItems="flex-start"
        >
          <Typography
            color="primaryDark.500"
            fontWeight="700"
            fontSize="11px"
            width="40%"
            whiteSpace="nowrap"
            align="left"
            marginTop="8px"
          >
            {data.label}
          </Typography>
          <CustomChip
            tooltipTitle={data.value}
            label={data.value && truncate(data.value, CHIP_LABEL_TRUNCATE_VALUE as number)}
            sx={{
              flexGrow: 0,
              flexShrink: 5,
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              textTransform: 'capitalize',
            }}
          />
        </Stack>
      ))}

      {isOverviewModalOpen && (
        <CompanyOverviewEditModal
          isModalOpen={isOverviewModalOpen}
          setIsModalOpen={setIsOverviewModalOpen}
        />
      )}
    </Stack>
  );
};

export default CompanyOverview;
